const ApiUrl = `${process.env.VUE_APP_API_PP_CIUDADANO}`
import axios from '@/interceptor-core'

export const requestAfiliacionMixin = {
  methods: {
    getListaActividad(body) {
      return axios.post(`${ApiUrl}/actividad/lista`, body)
    },
    getAfiliacion(id) {
      const body = {
        id: id
      }
      return axios.post(`${ApiUrl}/afiliacion/ver`, body)
    },
    getAfiliacionPendiente() {
      return axios.post(`${ApiUrl}/afiliacion/pendiente`)
    },
    enviarAfilicacion(body) {
      return axios.post(`${ApiUrl}/afiliacion`, body)
    },
    getTiposSolicitud() {
      return axios.get(`${ApiUrl}/solicitud/tipo`)
    },
    getComprobante(id) {
      const body = {
        id: id
      }
      return axios.post(`${ApiUrl}/afiliacion/certificado`, body)
    },
    getFaqs() {
      return axios.get(`${ApiUrl}/faq`)
    },
    undoAffiliation(id) {
      const body = {
        id: id
      }
      return axios.post(`${ApiUrl}/afiliacion/solicitud/cancelar`, body)
    },
    getListaPoliticanPartyByRegion(state) {
      const body = {
        state: state
      }
      return axios.post(`${ApiUrl}/partido-partidos/region`, body)
    },
  }
};
